<template>
    <LoadingComponent :props="loading" />
    <div class="db-card db-tab-div active">
        <div class="db-card-header items-center justify-between gap-4">
            <h3 class="db-card-title">{{ $t("label.progressive_web_app") }}</h3>
        
            <div class="flex items-center gap-2">
                <button
                    type="button"
                    class="db-btn h-9 py-2 px-3 text-white bg-primary ml-3"
                    @click="refreshFromServer"
                    :disabled="isRefreshingView"
                    :class="{ 'disabled:opacity-50 disabled:bg-gray': isRefreshingView }"
                >
                    <template v-if="isRefreshingView">
                        <svg class="inline-block animate-spin" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                            <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="3" opacity="0.25"></circle>
                            <path d="M22 12a10 10 0 0 1-10 10" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path>
                        </svg>
                    </template>
                    <template v-else>
                        <i class="fa-solid fa-arrows-rotate"></i>
                    </template>
                </button>
            </div></div>
        <div class="border-b bg-gray-100 p-3 px-5">
            <h2 class="text-base mb-1">{{ $t('label.important') }}</h2>
            <p class="text-sm">{{ $t('message.pwa_image_remainder') }}</p>
        </div>
        <div class="db-card-body">
            <form @submit.prevent="save">
                <div class="form-row">
                    <div class="form-col-12  sm:form-col-5">
                        <label for="splash" class="db-field-title required">
                            {{ $t("label.splash") }} (2048px,2732px)
                        </label>
                        <input @change="changeSplash" v-bind:class="errors.pwa_splash ? 'invalid' : ''" id="splash"
                            type="file" class="db-field-control" ref="splashProperty"
                            accept="image/png, image/jpeg, image/jpg" />
                        <small class="db-field-alert" v-if="errors.pwa_splash">{{
                            errors.pwa_splash[0]
                        }}</small>
                    </div>
                    <div class="form-col-12  sm:form-col-5">
                        <label for="icon" class="db-field-title required">
                            {{ $t("label.icon") }} (512px,512px)
                        </label>
                        <input @change="changeIcon" v-bind:class="errors.pwa_icon ? 'invalid' : ''" id="icon" type="file"
                            class="db-field-control" ref="iconProperty" accept="image/png, image/jpeg, image/jpg" />
                        <small class="db-field-alert" v-if="errors.pwa_icon">{{
                            errors.pwa_icon[0]
                        }}</small>
                    </div>

                    <div class="form-col-2 sm:form-col-2 mt-5">
                        <button type="submit" class="db-btn text-white bg-primary disabled:opacity-50 disabled:cursor-not-allowed" :disabled="!splash || !icon">
                            <i class="lab lab-fill-save"></i>
                            <span>{{ $t("button.save") }}</span>
                        </button>
                    </div>
                </div>
            </form>

            <div class="row mt-2">
                <div v-if="pwa.splash" class="col-6 sm:col-3">
                    <h3 class="text-lg font-medium text-center mb-2 text-paragraph">
                        {{ $t("label.splash") }}
                    </h3>
                    <img class="db-image db-image-no-border" alt="splash" :src="pwa.splash" />
                </div>
                <div v-if="pwa.icon" class="col-6 sm:col-3">
                    <h3 class="text-lg font-medium text-center mb-2 text-paragraph">
                        {{ $t("label.icon") }}
                    </h3>
                    <img class="db-image db-image-no-border" alt="icon" :src="pwa.icon" />
                </div>
            </div>

        </div>
    </div>
</template>
<script lang="js">
import LoadingComponent from "../../components/LoadingComponent";
import alertService from "../../../../services/alertService";

export default {
    name: 'PWAComponent',
    components: { LoadingComponent },
    data() {
        return {
            isRefreshingView: false,
            loading: {
                isActive: false,
            },
            splash: "",
            icon: "",
            errors: {},
        }
    },
    computed: {
        pwa: function () {
            return this.$store.getters["pwa/lists"];
        },
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        fetchData: function (showOverlay = true) {
            if (showOverlay) {
                this.loading.isActive = true;
            }
            return this.$store
                .dispatch("pwa/lists")
                .then((res) => {
                    if (showOverlay) {
                        this.loading.isActive = false;
                    }
                })
                .catch((err) => {
                    if (showOverlay) {
                        this.loading.isActive = false;
                    }
                });
        },
        refreshFromServer: function () {
            if (this.isRefreshingView) {
                return;
            }
            this.isRefreshingView = true;
            this.fetchData(false).then(() => {
                alertService.info(this.$t('button.refresh'));
                this.isRefreshingView = false;
            }).catch(() => {
                this.isRefreshingView = false;
            });
        },
        changeSplash: function (e) {
            this.splash = e.target.files[0];
        },
        changeIcon: function (e) {
            this.icon = e.target.files[0];
        },
        save: function () {
            try {
                this.loading.isActive = true;
                const formData = new FormData();
                if (this.splash) {
                    formData.append("pwa_splash", this.splash);
                }
                if (this.icon) {
                    formData.append("pwa_icon", this.icon);
                }
                this.$store
                    .dispatch("pwa/save", { form: formData })
                    .then((res) => {
                        this.loading.isActive = false;
                        alertService.successFlip(res.config.method === "post" ?? 0, this.$t("label.progressive_web_app"));
                        this.splash = "";
                        this.icon = "";
                        this.$refs.splashProperty.value = null;
                        this.$refs.iconProperty.value = null;
                        this.errors = {};
                    })
                    .catch((err) => {
                        this.loading.isActive = false;
                        this.errors = err.response.data.errors;
                    });
            } catch (err) {
                this.loading.isActive = false;
                alertService.error(err);
            }
        },
    }
}
</script>